var render = function render(){var _vm=this,_c=_vm._self._c;return _c('badge',{staticClass:"text-uppercase badge-lg",attrs:{"size":"lg","rounded":true,"type":_vm.type}},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }